import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Footer } from '@frame/ui-components/footer'
import { MultipleSelectOption } from '@frame/ui-components/multiple-select-option'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { Button } from '@frame/ui-primitives/button'
import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

import { OTHER_DOCUMENT_TYPE_LABEL } from '@documents/constants'
import { useDocumentsFlowContext } from '@documents/contexts/documents-flow-context'
import { OtherDocumentType } from '@documents/types'
import { useDirectTask } from '@frame/lib/hooks/useDirectTask'
import { useHeaderTitle } from '@frame/lib/hooks/useHeaderTitle'
import { useShowExitPrompt } from '@frame/lib/hooks/useShowExitPrompt'
import { routes } from '@frame/routes'
import { DataAttribute } from '@frame/types'

const options = Object.values(OtherDocumentType)
  .sort((a, b) => {
    if (a === OtherDocumentType.OTHER) return 1
    if (b === OtherDocumentType.OTHER) return -1
    return a.localeCompare(b)
  })
  .map((type) => ({
    value: type,
    label: OTHER_DOCUMENT_TYPE_LABEL[type],
  }))

export function SelectOtherDocumentType() {
  const navigate = useNavigate()

  const directTask = useDirectTask()
  const title = useHeaderTitle()
  const showExitPrompt = useShowExitPrompt()
  const { selectedOtherDocumentTypes, updateSelectedOtherDocumentTypes } = useDocumentsFlowContext()

  const isContinueDisabled = selectedOtherDocumentTypes.length === 0

  function handleChange(value: OtherDocumentType) {
    updateSelectedOtherDocumentTypes(value)
  }

  function handleContinue() {
    navigate(`${routes.uploadDocuments}/${directTask?.id}`, {
      state: {
        selectedSupportedDocumentType: false,
      },
    })
  }

  return (
    <>
      <WidgetHeaderWithNavigation title={title} showExitPrompt={showExitPrompt} />
      <Body
        data-cy={DataAttribute.DOCUMENTS_SCREEN_SELECT_OTHER_DOCUMENT_TYPES}
        className="flex flex-col gap-4 p-5"
        paddingTopOverride={0}
      >
        <H2 className="text-left">Specify document types</H2>
        <P>Select all that apply</P>
        {options.map((option) => (
          <MultipleSelectOption
            key={option.value}
            label={option.label}
            value={option.value}
            isSelected={selectedOtherDocumentTypes.includes(option.value)}
            onChange={() => handleChange(option.value)}
          />
        ))}
      </Body>
      <Footer
        buttons={{
          primary: (
            <Button disabled={isContinueDisabled} onClick={handleContinue}>
              Continue
            </Button>
          ),
        }}
      />
    </>
  )
}
